import { useEffect, useState } from 'react';

export function usePageLoadReady(): boolean {
  const [isPageLoaded, setIsPageLoaded] = useState(false);

  useEffect(() => {
    if (document.readyState === 'complete') {
      setIsPageLoaded(true);
      return;
    }

    const markPageAsLoaded = () => setIsPageLoaded(true);
    window.addEventListener('load', markPageAsLoaded, { once: true });
    return () => window.removeEventListener('load', markPageAsLoaded);
  }, []);

  return isPageLoaded;
}
